import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export function utm() {
  const p = new URLSearchParams(window.location.search);
  const out = {};
  ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => {
    const v = p.get(k) || sessionStorage.getItem(k);
    if (v) {
      out[k] = v;
      sessionStorage.setItem(k, v);
    }
  });
  return out;
}

export function track(name, extra = {}) {
  api.post("/events", { name, ...utm(), ...extra }).catch(() => {});
}

export const money = (price, currency) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: currency || "USD" }).format(price || 0);

export const STATUS_LABELS = {
  draft: "Draft",
  awaiting_lyrics: "Awaiting lyrics",
  awaiting_approval: "Awaiting your approval",
  awaiting_payment: "Awaiting payment",
  queued: "Queued",
  generating: "Generating",
  quality_review: "Quality review",
  ready: "Ready",
  delivered: "Delivered",
  needs_attention: "Needs attention",
  cancelled: "Cancelled",
};
